import React from 'react';

// material components
import {
    Toolbar,
    Typography,
    Tooltip,
    IconButton,
} from "@material-ui/core";

// material icons
import {
    AddCircle as Add,
} from '@material-ui/icons';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SaveIcon from '@material-ui/icons/Save';

// styling
import '../global/TableToolbar.css';

// constants
import PropTypes from "prop-types";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import {userInfoSelector, viewOnlySelector} from "../../redux/selectors/auth";
import withShipment from "../../withShipment";
import Utils from "../Utils/Utils";

class SettingsToolbar extends React.PureComponent {

    render() {
        return (
            <Toolbar className="toolbar"
                     style={{
                         backgroundColor: Utils.isValidColor(this.props.userInfo?.employeeColor)
                             ? this.props.userInfo?.employeeColor
                             :"#7896ff"}}
            >

                <div className="contextualMenu">
                    {/* Return control for pages that were opened FROM somewhere
                        else (the profile's Team tab links here). Only rendered
                        when a caller supplies onReturn, so every existing use of
                        this toolbar is unchanged. Navigation, not a write, so a
                        view-only user keeps it. */}
                    {!this.props.addingOrEditing && this.props.onReturn && (
                        <Tooltip title={this.props.returnLabel || "Back"}>
                            <IconButton onClick={this.props.onReturn}>
                                <KeyboardBackspaceIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                    {this.props.addingOrEditing ?
                        <>
                        <Tooltip title="Back">
                            <IconButton onClick={this.props.title === "" ? this.props.handleBack : this.props.handleClose}>
                                <KeyboardBackspaceIcon />
                            </IconButton>
                        </Tooltip>
                        {/* Optional: lets an edit form be saved from the
                            contextual menu, without walking to its last step. */}
                        {/* Central read-only enforcement for the third shared
                            toolbar (TopToolbar and CustomToolbar handle the
                            others). Save and the create (+) button are removed
                            for a viewer; Back and Next are navigation and stay.
                            See constants/readOnlyAccess.js. */}
                        {this.props.handleSave && !this.props.viewOnly &&
                            <Tooltip title="Save changes">
                                <IconButton onClick={this.props.handleSave}>
                                    <SaveIcon />
                                </IconButton>
                            </Tooltip>
                        }
                            {this.props.title === "" &&
                                <Tooltip title={"Next"}>
                                    <IconButton
                                        disabled={this.props.disableNextStep || this.props.onSavingStep}
                                        onClick={this.props.nextStep}>
                                        <ArrowForwardIcon/>
                                    </IconButton>
                                </Tooltip>
                            }
                        </>
                        :
                        (this.props.hideCreate || this.props.viewOnly ? null :
                            <Tooltip title={this.props.title === "Manage Employee" ? "Add Employee" : this.props.title}>
                                <IconButton onClick={this.props.handleCreateOpen}>
                                    <Add />
                                </IconButton>
                            </Tooltip>
                        )
                    }
                    

                </div>

                <Typography className="titleTypography" variant="h6" id="tableTitle">
                    {this.props.title}
                </Typography>

            </Toolbar>
        );
    }

}

SettingsToolbar.propTypes = {
    title: PropTypes.string,
    handleCreateOpen: PropTypes.func,
    handleEditOpen: PropTypes.func,
    selected: PropTypes.object,
    handleDeleteOpen: PropTypes.func,
    handleDeleteClose: PropTypes.func,
    handleDelete: PropTypes.func,
    deleteOpen: PropTypes.bool,
    handleSave: PropTypes.func,
    onReturn: PropTypes.func,
    returnLabel: PropTypes.string
}

SettingsToolbar.defaultProps = {
    title: "No title specified",
    selected: {},
    handleDelete: ()=>{},
    deleteOpen: false
}

const mapStateToProps = (state) => ({
    userInfo: userInfoSelector(state),
    viewOnly: viewOnlySelector(state)
})

export default withShipment({
    mapStateToProps,
}, SettingsToolbar);